import { ANALYTICS_TRIGGERS } from '@24i/nxg-sdk-smartott-shared/src/analytics/constants';
import { PlayerOpenResult, Payload } from '../types';
import { mapBase } from './mapBase';
import { getFormattedOriginalSourcePage } from '../utils';

export const mapPlayerOpen = (
    triggerName: ANALYTICS_TRIGGERS,
    payload: Payload
): PlayerOpenResult => {
    return {
        ...mapBase(payload),
        action: triggerName,
        event_trigger: triggerName,
        source_page: getFormattedOriginalSourcePage(payload),
        thing_id: payload.payload.asset?.id || '',
        source_rail: payload.payload.asset.sectionLabel,
    };
};
